import { signOut } from "firebase/auth";
import { useEffect, useState } from "react";
import { Form, Image } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { useAuthState } from "react-firebase-hooks/auth";
import { Link, useNavigate } from "react-router-dom";
import theKoreanMallLogo from "../../../assets/images/thekoreanmall-logo.png";
import theKoreanMallWhiteLogo from "../../../assets/images/thekoreanmall-logo-invert.png";
import auth from "../../../init.firebase";
import "./Navbar.scss";
import categoryData from "../../../data/category.json";
import { CgSearch } from "react-icons/cg";
import { RiAccountCircleFill } from "react-icons/ri";
import {
  MdOutlineKeyboardArrowDown,
  MdOutlineKeyboardArrowRight,
  MdOutlineShoppingBag,
} from "react-icons/md";
import { useGetAddToCartDataByEmailQuery } from "../../../redux/addToCart/addToCartApi";
import SearchModal from "../ResponsiveNavbar/SearchModal";
import { useDispatch } from "react-redux";
import { searchResult } from "../../../redux/products/productSlice";
import { useGetAllCategoryQuery } from "../../../redux/categories/categoriesApi";

const UiNavbar = ({ setShow: setShowModal }) => {
  const [user] = useAuthState(auth);
  const [haveUser, setHaveUser] = useState(true);
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [showLogoIcon, setShowLogoIcon] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    data: addToCartData,
    isLoading,
    isError,
  } = useGetAddToCartDataByEmailQuery(user?.email, { skip: haveUser });

  const {
    data: allCategories,
    isLoading: categoriesLoading,
    isError: categoriesError,
  } = useGetAllCategoryQuery();

  useEffect(() => {
    if (user?.email) {
      setHaveUser(false);
    }
  }, [user?.email]);

  //handle signOut
  const handleSignOut = () => {
    localStorage.clear();
    signOut(auth);
  };

  // handleSearch
  const handleSearch = (e) => {
    e.preventDefault();
    if (e.target?.value?.length > 0) {
      dispatch(searchResult(e.target.value));
      navigate("/product/search");
    }
  };

  const changeLogo = () => {
    if (window.scrollY >= 130) {
      setShowLogoIcon(true);
    } else {
      setShowLogoIcon(false);
    }
  };
  window.addEventListener("scroll", changeLogo);

  const totalQuantity = addToCartData?.products?.reduce(
    (tQuantity, currentQuantity) => tQuantity + currentQuantity?.quantity,
    0
  );

  let content = null;
  if (categoriesLoading) {
    content = <p className="text-primary"></p>;
  }
  if (!categoriesLoading && categoriesError) {
    content = <p className="text-danger">There was en error</p>;
  }
  if (
    !categoriesLoading &&
    !categoriesError &&
    allCategories?.result?.length === 0
  ) {
    content = <p>There is no categories</p>;
  }
  if (
    !categoriesLoading &&
    !categoriesError &&
    allCategories?.result?.length > 0
  ) {
    content = allCategories?.result?.map((grandParent) => {
      return grandParent?.children?.length > 0 ? (
        <TkmNavDropdown
          title={
            <div className="parent_hover_bg ">
              {grandParent?.title}{" "}
              <MdOutlineKeyboardArrowDown style={{ fontSize: "1.2rem" }} />
            </div>
          }
          id="basic-nav-dropdown"
          className="nav_dropdown_parent me-2 parent_hover"
        >
          {grandParent?.title?.toLowerCase() === "brands" ? (
            <div className="brand_parent">
              {grandParent?.children?.map((grandChild) => (
                <>
                  <NavDropdown.Item
                    as={Link}
                    to={`/category/children/${grandChild?._id}`}
                    className="text-uppercase"
                    style={{ width: "180px" }}
                  >
                    {grandChild?.title}
                  </NavDropdown.Item>
                </>
              ))}
            </div>
          ) : (
            grandParent?.children?.map((child) => {
              return child?.children?.length > 0 ? (
                <>
                  <TkmNavDropdown
                    title={
                      <div
                        className="d-flex align-items-center justify-content-between child_hover text-capitalize "
                        style={{ minWidth: "240px", maxWidth: "100%" }}
                      >
                        {child?.title}
                        <MdOutlineKeyboardArrowRight
                          style={{ fontSize: "1.2rem" }}
                        />
                      </div>
                    }
                    className="nav_dropdown parent_hover2 "
                  >
                    {child?.children?.map((grandChild) => (
                      <>
                        <NavDropdown.Item
                          as={Link}
                          to={`/category/children/${grandChild?._id}`}
                          className="text-capitalize child_hover2"
                          // style={{ width: "200px" }}
                        >
                          {grandChild?.title}
                        </NavDropdown.Item>
                        <NavDropdown.Divider
                          className="bg-white m-0"
                          style={{ opacity: "0.3" }}
                        />
                      </>
                    ))}
                  </TkmNavDropdown>
                  <NavDropdown.Divider
                    className="bg-white m-0"
                    style={{ opacity: "0.3" }}
                  />
                </>
              ) : (
                <>
                  <NavDropdown.Item
                    as={Link}
                    to={`/category/children/${child?._id}`}
                    className="text-capitalize"
                    // style={{ width: "200px" }}
                  >
                    {child?.title}
                  </NavDropdown.Item>
                  <NavDropdown.Divider
                    className="bg-white m-0"
                    style={{ opacity: "0.3" }}
                  />
                </>
              );
            })
          )}
        </TkmNavDropdown>
      ) : (
        <Nav.Link
          as={Link}
          to={`/category/children/${grandParent?._id}`}
          style={{ lineHeight: "4rem" }}
          className="me-3 single_link_parent"
        >
          <span className="single_link_child pb-1">{grandParent?.title}</span>
        </Nav.Link>
      );
    });
  }

  return (
    <>
      <p
        className="text-center text-white"
        style={{ backgroundColor: "crimson", fontSize: "0.875rem" }}
      >
        WELCOME TO THE KOREAN MALL
      </p>
      <div>
        <div className="d-flex justify-content-between w-100 px-3 align-items-center py-4">
          <Form className="search_container" onSubmit={handleSearch}>
            <input
              type="text"
              placeholder="Search..."
              aria-label="Search"
              onChange={(e) => handleSearch(e)}
            />
            <button>
              <CgSearch className="search_icon" />
            </button>
          </Form>
          <CgSearch
            className="search_small_icon"
            onClick={() => setShowSearchModal(true)}
            style={{
              width: "25px",
              height: "22px",
              marginRight: "10px",
            }}
          />
          <Navbar.Brand as={Link} to="/">
            <img className="brand_logo_image" src={theKoreanMallLogo} alt="" />
          </Navbar.Brand>
          <div
            className={`d-flex gap-4 ${user ? "" : "justify-content-end"}`}
            style={{ minWidth: "14rem" }}
          >
            {user && (
              <Nav.Link
                as={Link}
                to="/account"
                className="d-flex align-items-center justify-content-center "
              >
                Account{" "}
                <RiAccountCircleFill
                  className="ms-2"
                  style={{ fontSize: "1rem" }}
                />
              </Nav.Link>
            )}
            <div className="d-flex align-items-center">
              {user ? (
                <Nav.Link className="me-3" onClick={handleSignOut}>
                  Logout
                </Nav.Link>
              ) : (
                <Nav.Link as={Link} to="/account/login" className="me-3">
                  Login
                </Nav.Link>
              )}
              <div
                onClick={() => setShowModal(true)}
                className="m-auto d-flex align-items-center justify-content-center fw-normal add_cart_parent"
                style={{ fontSize: "12px" }}
              >
                <MdOutlineShoppingBag
                  style={{ width: "25px", height: "22px", cursor: "pointer" }}
                />
                <div className="add_cart">
                  <span>{totalQuantity ? totalQuantity : 0}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Navbar
        id="navbar_Link_parent"
        sticky="top"
        expand="lg"
        className=" px-3 bg-dark py-0"
      >
        <Navbar.Brand as={Link} to="/">
          <Image
            src={theKoreanMallWhiteLogo}
            className={`${
              showLogoIcon ? "text-white d-block" : "text-white d-none"
            }`}
            style={{ width: "200px" }}
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse>
          <Nav className="m-auto">{content}</Nav>
        </Navbar.Collapse>
        <div
          onClick={() => setShowModal(true)}
          className={`${
            showLogoIcon
              ? "m-auto d-flex align-items-center justify-content-center fw-normal add_cart_parent d-block"
              : "d-none"
          }`}
          style={{ fontSize: "12px" }}
        >
          <MdOutlineShoppingBag
            style={{
              width: "25px",
              height: "22px",
              cursor: "pointer",
              color: "white",
            }}
          />
          <div className="add_cart">
            <span>{totalQuantity ? totalQuantity : 0}</span>
          </div>
        </div>
        <SearchModal
          showSearchModal={showSearchModal}
          setShowSearchModal={setShowSearchModal}
        />
      </Navbar>
    </>
  );
};

export default UiNavbar;

const TkmNavDropdown = ({ title, children, id, className }) => {
  const [show, setShow] = useState(false);

  return (
    <NavDropdown
      title={title}
      id={id}
      className={className}
      show={show}
      onMouseEnter={() => setShow((prevState) => !prevState)}
      onMouseLeave={() => setShow(false)}
    >
      {children}
    </NavDropdown>
  );
};
